import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";
import type {
  BexrapportState,
  BexRapportListState,
  singleElementState,
} from "@/types/store";

const BexrapportListState: BexRapportListState = {
  data: [],
  error: null,
  loading: false,
  count: 0,
};

const singleElementState: singleElementState<any> = {
  data: [],
  error: null,
  loading: false,
};

export const bexState: BexrapportState = {
  bexrapports: BexrapportListState,
  bexrapport: singleElementState,
};

export const BexRapportModule = {
  namespaced: true,
  state: bexState,
  actions,
  mutations,
  getters,
};
